// extracted by mini-css-extract-plugin
export default {"productDescription":"j3-z","featuredDescription":"k3-z","description":"l3-z","more":"m3-z","brandLogo":"n3-z","descriptionSku":"o3-z"};